import { render, staticRenderFns } from "./DestinationTaggingForm.vue?vue&type=template&id=06d9b38c&scoped=true&"
import script from "./DestinationTaggingForm.vue?vue&type=script&lang=js&"
export * from "./DestinationTaggingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d9b38c",
  null
  
)

export default component.exports